import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Browser hand-off page for the Android app.
 * Chrome can see the installed UPI apps (Google Pay / PhonePe / Paytm…) that a
 * WebView cannot, so the app opens this page externally and we hand the session
 * straight to Cashfree with a full-page redirect.
 */
export default function PayPage() {
  const [params] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const session = params.get("session");
    const env = params.get("env") === "production" ? "production" : "sandbox";
    if (!session) { setError("This payment link is incomplete. Please start the payment again from the app."); return; }

    let tries = 0;
    const launch = () => {
      if (!window.Cashfree) {
        if (tries++ > 40) { setError("Payment page could not load. Please check your connection and try again."); return; }
        setTimeout(launch, 250);
        return;
      }
      try {
        window.Cashfree({ mode: env }).checkout({ paymentSessionId: session, redirectTarget: "_self" });
      } catch (e) {
        setError("Payment could not be started. Please try again from the app.");
      }
    };
    launch();
  }, [params]);

  return (
    <div data-testid="pay-handoff-page" style={{ minHeight: "100vh", background: "#120021", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
      <div className="glass-card" style={{ maxWidth: "380px", width: "100%", textAlign: "center", padding: "32px" }}>
        <div className="font-cinzel" style={{ color: "#FFD166", fontSize: "1.2rem", marginBottom: "10px" }}>
          {error ? "Payment unavailable" : "Opening secure checkout…"}
        </div>
        <p data-testid="pay-handoff-msg" style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.88rem", lineHeight: 1.6 }}>
          {error || "Choose UPI and pick your app — Google Pay, PhonePe, Paytm or any other. Return to the AstroFate app once the payment is done; your plan activates automatically."}
        </p>
      </div>
    </div>
  );
}
